import AbrdnButton from 'components/Generic/Buttons/AbrdnButton';
import { MouseEventHandler } from 'react';

type StepSelectorProps = {
  currentStep: number;
  prevStepLabel: string;
  nextStepLabel: string;
  showSubmit: boolean;
  showNextStepBtn: boolean;
  prevStepHandler: () => void;
  nextStepHandler: () => void;
  submitForm: MouseEventHandler<HTMLButtonElement>;
  isLoading: boolean;
};

const StepSelector = ({
  currentStep,
  prevStepLabel,
  nextStepLabel,
  showSubmit,
  showNextStepBtn,
  prevStepHandler,
  nextStepHandler,
  submitForm,
  isLoading,
}: StepSelectorProps) => {
  return (
    <div className="mt-5 step-select-section">
      <div className="container my-5">
        {currentStep !== 1 && (
          <AbrdnButton
            onClick={prevStepHandler}
            className="prev-button me-2 mb-3 mb-md-0"
            buttonType="secondary"
          >
            <i className="bi-arrow-left me-2" aria-hidden="true" />
            {prevStepLabel}
          </AbrdnButton>
        )}
        {showNextStepBtn && (
          <AbrdnButton
            onClick={nextStepHandler}
            className="prev-button me-2 mb-3 mb-md-0"
            buttonType="primary"
          >
            {nextStepLabel}
            <i className="bi-arrow-right ms-2 text-white" aria-hidden="true" />
          </AbrdnButton>
        )}
        {showSubmit && (
          <AbrdnButton onClick={submitForm} type="button" buttonType="primary" disabled={isLoading}>
            Submit
            <i className="bi-arrow-right ms-2 text-white" aria-hidden="true" />
          </AbrdnButton>
        )}
      </div>
    </div>
  );
};

export default StepSelector;
